import { SupportedLocales } from "src/utils";

type ImageMap = Record<string, ImageLocales>;
type LocalizedImageRecord = Record<SupportedLocales, `https://${string}`>;
type ImageLocales =
    | Partial<LocalizedImageRecord> & Record<"en", `https://${string}`>;

const imageMap = {
    row1: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jpd-pt-impact_assessment.webp"
    },
    row2: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jpd-pt-performance.webp"
    },
    row3: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jpd-pt-improve_discoverability.webp"
    },
    workFlow: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/workflow-diagram.webp"
    },
    workFlowMobile: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-mobile-workflow-diagram.webp"
    },
    pronouncedCta: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Networking_people_spot@2x.webp"
    },
    tab1: {
        en: "https://wac-cdn.atlassian.com/dam/jcr:5b62ada3-3447-43e2-845a-491e99c2cfd1/TAB_1.svg"
    },
    tab2: {
        en: "https://wac-cdn.atlassian.com/dam/jcr:5f94b814-a0d9-49c3-acaf-39b9e8fb0deb/TAB_2.svg"
    },
    tab3: {
        en: "https://wac-cdn.atlassian.com/dam/jcr:932e7533-89a4-42f6-a9d6-f1113109b8f6/TAB_3.svg"
    },
    tab4: {
        en: "https://wac-cdn.atlassian.com/dam/jcr:9bfb78ef-dce1-451b-b4f4-75775d9a93c8/TAB_4.svg"
    }
} as const satisfies ImageMap;

const getCorrespondingImageMap = (
    descriptor: keyof typeof imageMap
): ImageLocales => {
    if (imageMap.hasOwnProperty(descriptor)) {
        return imageMap[descriptor];
    }

    throw new Error(`Unknown descriptor: ${descriptor}`);
};

export const getLocalizedImage = (
    descriptor: keyof typeof imageMap,
    locale: SupportedLocales
): string => {
    const map = getCorrespondingImageMap(descriptor);

    return map[locale] ?? map["en"];
};
